// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__Uemmj","Tabs__link":"Tabs_Tabs__link__4y2mT","isActive":"Tabs_isActive__uNunm"};